<template>
  <div class="pc esign-header-container">
    <div :class="['esign-header-wrapper', current || headerHighlight ? 'esign-header-highlight' : '']" id="esign-header-wrapper">
      <header class="esign-header">
        <!-- <div class="esign-left"> -->
        <h1 class="esign-logo">
          <a href="/"><img src="@/assets/images/blacklogo.png"/></a>
        </h1>
        <nav class="esign-nav" id="esign-nav">
          <span
            v-for="(menu, index) in navConfig"
            :data-index="index"
            :key="menu.id"
            :class="['menu-text', menu.link ? '' : 'menu-down', menu.id === current ? 'active' : '']"
            @mouseover="handleMouseover(menu.id)"
            @mouseout="handelMouseout()"
          >
            <template v-if="menu.link"
              ><a :href="menu.link">{{ menu.title }}</a></template
            >
            <template v-else>{{ menu.title }}</template>
          </span>
        </nav>
        <!-- </div> -->
        <div class="esign-right space">
          <div class="space-item app-wrapper" id="app-wrapper">
            <span class="text item-app" @mouseover="handleAppMouseover()" @mouseout="handelAppMouseout()">客户端/小程序/APP</span>
            <div v-show="isHoverApp" class="app-container">
              <ul class="app-list" id="app-list">
                <li
                  v-for="item in appList"
                  :key="item.id"
                  class="item-wrapper"
                  @mouseover="handleAppItemMouseover(item.id)"
                  @mouseout="handelAppItemMouseout()"
                >
                  <span :class="`title ${`custom_icon_download_${item.id}`} ${currentApp === item.id ? 'active' : ''}`">{{
                    item.title
                  }}</span>
                  <!-- a link -->
                  <template v-if="item.link">
                    <a v-show="currentApp === item.id" :href="item.link" class="app-code-wrapper">
                      <img :src="item.code" />
                      <div class="desc">{{ item.desc }}</div>
                    </a>
                  </template>
                  <!-- div -->
                  <div v-else v-show="currentApp === item.id" class="app-code-wrapper">
                    <img :src="item.code" />
                    <div class="desc">{{ item.desc }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="space-item tel" id="tel-wrapper" @mouseover="handleTelMouseover()" @mouseout="handelTelMouseout()">
            <div><i class="icon-tel"></i><span class="text red-text">400-0878-198</span></div>
            <ul v-show="isHoverTel" class="tel-down">
              <li>
                <div class="tel-down-tit">销售热线</div>
                <a href="tel:0571-85785223" class="tel-down-val">0571-85785223</a>
              </li>
              <li>
                <div class="tel-down-tit">售后服务</div>
                <a href="tel:400-0878-198" class="tel-down-val">400-0878-198</a>
              </li>
            </ul>
          </div> -->
          <!-- 泽元：onclick="trial_dialog_or_window(event, true, 'dialog')" -->
          <!-- <EButton class="space-item free-btn" type="primary" @click="handleClickFree">免费试用</EButton> -->
          <!-- <a class="space-item login-btn" href="/site/quotation" rel="nofollow" style="width:88px;height:36px;">查看价格</a>
          <a class="space-item login-btn" href="https://web.esign.cn" rel="nofollow">登录</a> -->

          <a class="space-item link-btn" href="/site/quotation" rel="nofollow">查看价格</a>
          <a class="space-item link-btn" href="https://web.esign.cn/workspace/home" rel="nofollow">登录</a>
          <a class="space-item link-btn" href="https://h5.esign.cn/usercenterFront/regist?pub=esign" rel="nofollow">注册</a>
          <!-- 泽元：onclick="trial_dialog_or_window(event, true, 'dialog')" -->
          <EButton class="space-item free-btn" type="primary" @click="handleClickFree">免费试用</EButton>
        </div>
      </header>
    </div>
    <!-- 菜单展开 -->
    <div class="menu-container" id="menu-container">
      <div v-for="menu in navConfig" :key="menu.id" class="menu-sub-wrapper">
        <template v-if="!menu.link">
          <template v-if="menu.layout === 'three-column-layout'">
            <ThreeColumnLayout
              v-show="current === menu.id"
              :menu="menu"
              class="menu-sub-content"
              @mouseover="handleMouseover(menu.id)"
              @mouseout="handelMouseout()"
            ></ThreeColumnLayout>
          </template>
          <!-- default layout start -->
          <template v-else>
            <TwoColumnLayout
              v-show="current === menu.id"
              :menu="menu"
              class="menu-sub-content"
              @mouseover="handleMouseover(menu.id)"
              @mouseout="handelMouseout()"
            ></TwoColumnLayout>
          </template>
          <!-- default layout end -->
        </template>
      </div>
    </div>
    <!-- 菜单展开 end -->
  </div>
</template>
<script>
import EButton from '@/components/basics/Button.vue'
import TwoColumnLayout from './TwoColumnLayout.vue'
import ThreeColumnLayout from './ThreeColumnLayout.vue'
export default {
  components: {
    EButton,
    TwoColumnLayout,
    ThreeColumnLayout,
  },
  props: {
    navTree: {
      type: Array,
      default() {
        return []
      },
    },
    appList: {
      type: Array,
      default() {
        return []
      },
    },
    headerHighlight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navConfig: this.navTree,
      current: '',
      timer: null,
      isHoverApp: false, // app/小程序 hover
      currentApp: this.appList[0].id,
      isHoverTel: false, // tel hover
    }
  },
  methods: {
    handleClickFree() {
      this.$emit('showDialog')
    },
    handleMouseover(current) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.current = current
      // document.getElementsByTagName('html')?.[0]?.setAttribute('style', 'overflow: hidden; width: calc(100% - 17px);')
      // document.getElementsByClassName('esign-header-container')?.[0]?.setAttribute('style', 'width: calc(100% - 17px);')
    },
    handelMouseout() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.current = ''
        // document.getElementsByTagName('html')?.[0]?.setAttribute('style', '')
        // document.getElementsByClassName('esign-header-container')?.[0]?.setAttribute('style', '')
      }, 300)
    },

    handleAppMouseover() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.isHoverTel = false
      this.current = ''
      this.isHoverApp = true
    },
    handelAppMouseout() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.isHoverApp = false
      }, 300)
    },

    handleAppItemMouseover(current) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.currentApp = current
      this.isHoverApp = true
      this.isHoverTel = false
    },
    handelAppItemMouseout() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.currentApp = this.appList[0].id
        this.isHoverApp = false
      }, 300)
    },

    handleTelMouseover() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.isHoverTel = true
      this.current = ''
      this.isHoverApp = false
    },
    handelTelMouseout() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.isHoverTel = false
      }, 300)
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/style/variable.less';
@headerHeight: 60px;
.esign-header-container {
  position: fixed;
  width: 100%;
  z-index: 10001;
  top: 0;
  left: 0;
}

.esign-header-wrapper {
  width: 100%;
  height: @headerHeight;
  padding: 0 3%;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.5);
}

.esign-header-highlight {
  background: #ffffff;
}

.esign-header {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// .esign-left {
//   display: flex;
//   align-items: center;
// }

.esign-logo {
  margin-right: 56px;

  a {
    display: inline-block;
    width: 103px;
    height: 28px;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.esign-nav {
  display: flex;
  padding-left: 3.3%;

  .menu-text {
    color: @default-color;
    font-size: 14px;
    line-height: @headerHeight;
    padding: 0 20px;
    cursor: default;
    font-family: 'PingFangSC-Medium, PingFang SC';
    font-weight: 500;

    a {
      color: @default-color;
      font-size: 14px;
      font-family: 'PingFangSC-Medium, PingFang SC';
      font-weight: 500;
    }
  }

  .menu-down {
    &::after {
      display: inline-block;
      content: ' ';
      width: 6px;
      height: 6px;
      margin-left: 6px;
      background: #fff;
      border-left: 1px solid @default-color;
      border-bottom: 1px solid @default-color;
      transform: rotate(-45deg);
      vertical-align: 0.2em;
    }
  }

  .menu-text.active {
    color: @primary-color;
    a {
      color: @primary-color;
    }

    &::after {
      border-color: @primary-color;
      transform: rotate(135deg);
      vertical-align: -0.1em;
    }
  }
}
.login-btn {
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 2px;
  line-height: 26px;
  background: transparent;
  color: @primary-color;
  border: 1px solid transparent;
  border-color: @primary-color;
  text-align: center;

  &:hover {
    background: @primary-color;
    border-color: @primary-color;
    color: #fff;
  }
}
.login-btn,
.free-btn {
  width: 88px;
  height: 36px;
}

.app-wrapper {
  position: relative;
  min-width: 76px;

  .item-app {
    display: inline-block;
    height: @headerHeight;
    line-height: @headerHeight;
    cursor: default;
    color: @default-color;
    &:hover {
      color: @primary-color;
    }
  }
}

.app-container {
  position: absolute;
  top: 60px;
}

.app-list {
  position: relative;
  background: #f5f5f5;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;

  .title.active {
    border-left: 2px solid @primary-color;
    background-color: #fff;
  }

  .title {
    display: inline-block;
    width: 120px;
    height: 40px;
    padding-left: 18px;
    line-height: 40px;
    font-size: 14px;
    border-left: 2px solid transparent;
    cursor: default;

    &::before {
      margin-right: 6px;
      font-size: 20px;
      color: #666;
      vertical-align: -0.1em;
    }
  }

  .custom_icon_download_wechat {
    &:hover {
      &::before {
        color: #07b906;
      }
    }
  }
  .custom_icon_download_alipay {
    &:hover {
      &::before {
        color: #027aff;
      }
    }
  }
  .custom_icon_download_ios {
    &:hover {
      &::before {
        color: #333;
      }
    }
  }
  .custom_icon_download_android {
    &:hover {
      &::before {
        color: #8ab928;
      }
    }
  }
  .custom_icon_download_dingtalk {
    &:hover {
      &::before {
        color: #161fff;
      }
    }
  }
  .custom_icon_download_client {
    &::before {
      display: inline-block;
      content: '';
      width: 20px;
      height: 20px;
      background-image: url('https://www.esign.cn/images/clientDownload/custom_icon_download_client_icon1.png');
      background-repeat: no-repeat;
      background-size: 18px;
      background-position: center;
      vertical-align: -0.25em;
    }
    &:hover {
      &::before {
        background-image: url('https://www.esign.cn/images/clientDownload/custom_icon_download_client_icon2.png');
      }
    }
  }

  .app-code-wrapper {
    position: absolute;
    left: 120px;
    top: 0;
    width: 204px;
    height: 240px;
    background: #fff;
    text-align: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 180px;
      height: 180px;
    }

    .desc {
      font-size: 14px;
      color: #888;
      line-height: 36px;
    }
  }

  .custom_icon_download_client {
    &::before {
      content: '';
      width: 20px;
      height: 20px;
      background-image: url(https://www.esign.cn/images/clientDownload/custom_icon_download_client_icon1.png);
      background-repeat: no-repeat;
      background-size: 18px;
      background-position: center;
    }
  }
}

.space {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .space-item {
    margin-left: 26px;
  }

  .link-btn {
    font-size: 14px;
    font-weight: 500;
    color: @default-color;
    line-height: 20px;
    &:hover {
      color: @primary-color;
    }
  }
}

.esign-right {
  flex: 1;
  .text {
    font-size: 14px;
  }

  .red-text {
    color: @primary-color;
  }

  .pointer {
    cursor: pointer;
  }
  .tel {
    position: relative;
    min-width: 112px;
    .icon-tel {
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 5px;
      vertical-align: -0.05em;
      background: url('../../assets/images/new-header/icon-tel.png') no-repeat;
      background-size: 100%;
    }
    .text {
      font-size: 16px;
    }
  }
  .tel-down {
    position: absolute;
    top: 29px;
    width: 174px;
    padding: 5px 19px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 2px 6px 0px rgba(209, 209, 209, 0.5);
    border-radius: 2px;
    backdrop-filter: blur(10px);
    li {
      padding: 9px 0;
      border-bottom: 1px solid #dbdbdb;
      &:last-child {
        border-bottom: 0;
      }
    }

    .tel-down-tit {
      margin-bottom: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #272727;
      line-height: 20px;
    }
    .tel-down-val {
      font-size: 16px;
      font-weight: 500;
      color: #e63740;
      line-height: 20px;
    }
  }
}

.menu-container {
  width: 100%;
}

.menu-sub-wrapper {
  width: 100%;

  .menu-sub-content {
    display: flex;
    min-height: 300px;
    // max-height: 390px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 6px 6px 0px rgba(230, 230, 230, 0.5);
    backdrop-filter: blur(30px);
  }
}
@media screen and (max-width: 1680px) {
  .esign-nav {
    padding-left: 0;
  }
}
@media screen and (max-width: 1550px) {
  .esign-logo {
    margin-right: 26px;
  }

  .esign-nav .menu-text {
    padding: 0 15px;
  }
}
@media screen and (max-width: 1380px) {
  .esign-header-wrapper {
    padding: 0 20px;
  }

  .esign-logo {
    margin-right: 15px;
  }

  .esign-nav .menu-down {
    &::after {
      margin-left: 4px;
    }
  }

  .login-btn {
    width: 60px;
    padding-left: 0;
    padding-right: 0;
  }
  .space .space-item {
    margin-left: 16px;
  }
}
@media screen and (max-width: 1270px) {
  .esign-header-wrapper {
    height: 111px;
    background: #fff;
  }
  .esign-header {
    position: relative;
    align-items: flex-start;
  }
  .esign-logo {
    display: flex;
    align-items: center;
    height: 60px;
  }
  .esign-nav {
    position: absolute;
    bottom: 0px;
  }
  .esign-nav .menu-text {
    line-height: 51px;
  }
}
</style>
